































import { Vue, Component } from "vue-property-decorator";
import { Category as ICategory } from "@/api-v2/category/models/category";
import api, { categoryApi } from "@/getinfo-api";
import { AxiosError } from "axios";
import { ErrorResponse as IErrorResponse } from "@/api/models/error-response";
import { ValidationErrorResponse as IValidationErrorResponse } from "@/api/models/validation-error-response";
import EditorWithFile from "@/components/EditorWithFile.vue";
import CustomButton from "@/components/form/CustomButton.vue";
import { getCurrentCompanyId } from "@/plugins/roles";
@Component({
  components: { CustomButton, EditorWithFile }
})
export default class CategoryForm extends Vue {
  title!: string;
  description!: string;
  isSavingProcess: boolean = false;

  data() {
    return {
      title: undefined,
      description: undefined
    };
  }

  get companyId() {
    return getCurrentCompanyId();
  }

  createCategory() {
    this.isSavingProcess = true;
    let params: ICategory = {
      companyId: this.companyId,
      title: this.title,
      description: this.description
    };
    categoryApi.category
      .createCategory(params)
      .then(() => {
        this.$router.push({
          name: "categoryList"
        });
      })
      .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
        this.$store.dispatch("errorException", {
          vm: this,
          error: err.response
        });
      })
      .finally(() => {
        this.isSavingProcess = false;
      });
  }
}
